const COMPLEMENT_ALLOWED_CHAR_PATTERN = /[0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑýÝ :.,/'-]/;

type ComplementMaskFactory = ((value?: string) => string) & {
  patterns: {
    C: {
      pattern: RegExp;
    };
  };
};

export const ComplementMask: ComplementMaskFactory = Object.assign(
  () => 'C*',
  {
    patterns: {
      C: {
        pattern: COMPLEMENT_ALLOWED_CHAR_PATTERN,
      },
    },
  }
);
